console.log('App.js loaded');

document.addEventListener("DOMContentLoaded", function() {
  const modal = document.getElementById("appointmentModal");
  const closeBtn = document.getElementById("closeModal");

  // If modal exists (for safety)
  if (!modal || !closeBtn) return;

  // Check if modal was already closed in this session
  const modalClosed = sessionStorage.getItem("appointmentModalClosed");

  if (!modalClosed) {
    // Show modal after 1 second (only if not previously closed)
    setTimeout(() => {
      modal.classList.add("active");
    }, 1000);
  }

  // Close modal when X button clicked
  closeBtn.addEventListener("click", () => {
    modal.classList.remove("active");
    sessionStorage.setItem("appointmentModalClosed", "true");
  });

  // Close modal when clicking outside content
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.classList.remove("active");
      sessionStorage.setItem("appointmentModalClosed", "true");
    }
  });
});